
import { defineComponent, inject, onMounted, ref } from 'vue';
import { Swiper } from 'swiper/vue';
import SwiperCore, { Navigation, Pagination } from 'swiper';

SwiperCore.use([Navigation, Pagination]);

export default defineComponent({
  props: {
    options: {
      type: Object,
      default: {
        speed: 1000,
        spaceBetween: 0,
        threshold: 10,
        centerInsufficientSlides: true,
        watchOverflow: true,
        loop: true,
        navigation: {
          prevEl: '.ce-job-hero-btn--prev',
          nextEl: '.ce-job-hero-btn--next',
        },
        pagination: {
          el: '.ce-job-hero-pagination',
          clickable: true,
          type: 'fraction',
        },
      }
    }
  },
  setup(props) {
    const swiperOptions = ref(props.options);
    const lazyLoad: any = inject('lazyLoad');
    onMounted(() => {
      lazyLoad.update();
    });

    return { swiperOptions };
  },
  components: {
    swiper: Swiper,
  }
});
